import { CardLabel } from "./CardLabel";
export default CardLabel;
